import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../Context/ThemeContextProvider';
import User from './User';

export const Dashboard = () => {

  const dupli=[
    {
      "id": 1,
      "name": "Nrupul Dev",
      "position": "CTO",
      "level": 15,
      "points": 23456,
      "img": "https://i.pinimg.com/736x/de/59/4e/de594ec09881da3fa66d98384a3c72ff.jpg"
    },
    {
      "id": 2,
      "name": "Prateek",
      "position": "CEO",
      "level": 15,
      "points": 22456,
      "img": "https://i.pinimg.com/736x/de/59/4e/de594ec09881da3fa66d98384a3c72ff.jpg"
    },
    {
      "id": 3,
      "name": "Yogesh",
      "position": "SVP",
      "level": 15,
      "points": 24536,
      "img": "https://i.pinimg.com/736x/de/59/4e/de594ec09881da3fa66d98384a3c72ff.jpg"
    }
  ]

  const { isDarkTheme } = useContext(ThemeContext);
  const { changeTheme } = useContext(ThemeContext);
  const [data, setData] = useState(dupli);
  

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`http://localhost:8080/userData`);
        const jsondata = await res.json();
        console.log(jsondata);
        setData([...jsondata,...dupli]); // Fix the typo here
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);

  return (
    <div data-testid="dashboard-cont" style={{'background-color': isDarkTheme ? 'black' : 'white',}}>
      <select data-testid="select-theme" onChange={()=>changeTheme()}>
        <option>Light Theme</option>
        <option>Dark Theme</option>
      </select>
      {/* map through the users and render User component */}
      <h1 style={{color: isDarkTheme? 'white':'black', background: isDarkTheme? 'black':'white'}}>All  Active Users</h1>
      {data.map((user) => (
        <User key={user.id} isDarkTheme={isDarkTheme} user={user} />
      ))}
    </div>
  );
};
